import * as React from "react";
import { Anchor, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const products = [{
  id: "tuna-water",
  name: "Tuna in Water",
  price: "$12.00",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_tuna_water.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_tuna_water.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_tuna_water.png-wvc-sizes",
    alt: "Can of The Miss Yvonne Tuna in Water"
  },
  url: "/ShopPage"
}, {
  id: "tuna-olive-oil",
  name: "Tuna in Olive Oil",
  price: "$14.00",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_tuna_olive_oil.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_tuna_olive_oil.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_tuna_olive_oil.png-wvc-sizes",
    alt: "Can of The Miss Yvonne Tuna in Olive Oil"
  },
  url: "/ShopPage"
}, {
  id: "salmon-water",
  name: "Salmon in Water",
  price: "$15.00",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_salmon_water.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_salmon_water.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_salmon_water.png-wvc-sizes",
    alt: "Can of The Miss Yvonne Salmon in Water"
  },
  url: "/ShopPage"
}, {
  id: "salmon-olive-oil",
  name: "Salmon in Olive Oil",
  price: "$16.00",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_salmon_olive_oil.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_salmon_olive_oil.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_salmon_olive_oil.png-wvc-sizes",
    alt: "Can of The Miss Yvonne Salmon in Olive Oil"
  },
  url: "/ShopPage"
}, {
  id: "black-cod-olive-oil",
  name: "Black Cod in Olive Oil",
  price: "$18.00",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_black_cod_olive_oil.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_black_cod_olive_oil.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_black_cod_olive_oil.png-wvc-sizes",
    alt: "Can of The Miss Yvonne Black Cod in Olive Oil"
  },
  url: "/ShopPage"
}, {
  id: "galley-box",
  name: "The Galley Box",
  price: "$65.00",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_galley_box.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_galley_box.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/tinned_galley_box.png-wvc-sizes",
    alt: "The Galley Box assorted tinned seafood collection"
  },
  url: "/ShopPage"
}];
export default function TinnedReadyToEat() {
  return <section id="tinned-ready-to-eat" className="bg-background text-foreground relative overflow-hidden py-24 md:py-40">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} />

      <div className="mx-auto max-w-[1440px] px-8 relative z-10">
        {}
        <div className="mb-16 flex flex-col items-center text-center md:mb-24">
          <div className="mb-6 flex items-center gap-4">
            <div className="h-[1px] w-12 bg-border" />
            <Anchor className="size-5 text-primary" strokeWidth={1.5} />
            <div className="h-[1px] w-12 bg-border" />
          </div>
          <span className="font-mono text-muted-foreground mb-4 text-xs uppercase tracking-[0.25em]">
            Provisions
          </span>
          <h2 className="font-default text-foreground mb-6 text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
            Tinned & Ready to Eat
          </h2>
          <p className="font-sans text-muted-foreground max-w-2xl text-lg leading-relaxed">
            Experience the pure taste of the Gulf, preserved at the peak of
            freshness. Our heritage tinned seafood is ready for your next
            voyage, whether on deck or at the dining table.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {products.map((product, i) => <Card key={product.id} data-index={i} className="group border-border bg-card hover:border-primary rounded-sm shadow-sm transition-colors duration-300 overflow-hidden flex flex-col">
              <div className="relative aspect-[4/3] overflow-hidden bg-muted/30">
                <img src={product.image.src} data-wvc-srcset={product.image.srcset} data-wvc-sizes={product.image.sizes} alt={product.image.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                {}
                <div className="absolute bottom-4 left-4 -rotate-90 origin-bottom-left">
                  <span className="font-mono text-[10px] tracking-widest text-foreground/40 uppercase">
                    30° 24' N / 88° 49' W
                  </span>
                </div>
              </div>

              <CardHeader className="pb-2 pt-6">
                <CardTitle className="font-default text-foreground text-2xl font-semibold">
                  {product.name}
                </CardTitle>
              </CardHeader>

              <CardContent className="flex-grow pb-6">
                <p className="font-mono text-muted-foreground text-sm tracking-wider">
                  {product.price}
                </p>
              </CardContent>

              <CardFooter className="pt-0">
                <Button asChild variant="outline" className="w-full rounded-sm border-foreground text-foreground font-mono uppercase tracking-wider hover:bg-foreground hover:text-background transition-colors duration-150">
                  <Link to={product.url}>Shop Now</Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>

        {}
        <div className="mt-16 flex justify-center md:mt-24">
          <Button asChild size="lg" className="bg-secondary text-secondary-foreground rounded-sm px-10 py-6 font-mono text-sm uppercase tracking-widest hover:bg-foreground hover:text-background transition-colors duration-150">
            <Link to="/ShopPage">
              Shop All Tinned Seafood
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}